"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_CUS_BASE_DELETE = exports.API_CUS_BASE_FETCH = exports.API_CUS_BASE_LIST = exports.API_CUS_BASE_SAVE = void 0;
var API_CUS_BASE_SAVE;
(function (API_CUS_BASE_SAVE) {
    API_CUS_BASE_SAVE.PATH = '/cus-base/save';
    API_CUS_BASE_SAVE.PURPOSE = '단체복 기초상품 저장';
})(API_CUS_BASE_SAVE = exports.API_CUS_BASE_SAVE || (exports.API_CUS_BASE_SAVE = {}));
var API_CUS_BASE_LIST;
(function (API_CUS_BASE_LIST) {
    API_CUS_BASE_LIST.PATH = '/cus-base/list';
    API_CUS_BASE_LIST.PURPOSE = '단체복 기초상품 목록조회';
})(API_CUS_BASE_LIST = exports.API_CUS_BASE_LIST || (exports.API_CUS_BASE_LIST = {}));
var API_CUS_BASE_FETCH;
(function (API_CUS_BASE_FETCH) {
    API_CUS_BASE_FETCH.PATH = '/cus-base/fetch';
    API_CUS_BASE_FETCH.PURPOSE = '단체복 기초상품 상세조회';
})(API_CUS_BASE_FETCH = exports.API_CUS_BASE_FETCH || (exports.API_CUS_BASE_FETCH = {}));
var API_CUS_BASE_DELETE;
(function (API_CUS_BASE_DELETE) {
    API_CUS_BASE_DELETE.PATH = '/cus-base/delete';
    API_CUS_BASE_DELETE.PURPOSE = '단체복 기초상품 삭제';
})(API_CUS_BASE_DELETE = exports.API_CUS_BASE_DELETE || (exports.API_CUS_BASE_DELETE = {}));
//# sourceMappingURL=api-cus-base.js.map